import axiosConfig from "../api/axios.config";
import { onMessageListener } from "../../libraries/firebaseInit";

const bootstrapApp = async () => {
  await axiosConfig()
  await onMessageListener()
}
export default bootstrapApp
